import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const ResendActivationContainer = styled.div`
  background-color: ${({ theme }: any) => theme.colors.greyscale.white};
  padding: ${rem(32)};
  border-radius: ${rem(4)};
  min-height: ${rem(320)};
  display: flex;
  flex-direction: column;
  max-width: ${rem(400)};
  width: 100%;
  margin: 0 auto;
`;

export const Title = styled.h2`
  font-size: ${rem(20)};
  font-weight: 600;
  margin: 0 0 ${rem(8)} 0;
  color: #1a1a1a;
`;

export const Description = styled.p`
  font-size: ${rem(14)};
  color: #4a4a4a;
  margin: 0 0 ${rem(24)} 0;
  line-height: 1.5;
`;

export const FormGroup = styled.div`
  margin-bottom: ${rem(24)};
`;

export const BackLink = styled.a`
  display: inline-block;
  margin-top: ${rem(16)};
  font-size: ${rem(14)};
  color: ${({ theme }: any) => theme.colors.dataVisualization.teal};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const ConfirmationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${rem(16)} 0;
`;

export const ConfirmationMessage = styled.p`
  font-size: ${rem(14)};
  color: #4a4a4a;
  line-height: 1.6;
  margin: 0 0 ${rem(24)} 0;
`;

export const ConfirmationIcon = styled.div`
  font-size: ${rem(48)};
  margin-bottom: ${rem(16)};
  color: ${({ theme }: any) => theme.colors.dataVisualization.teal};
`;
